// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export const locales = [
  {
    "id": "zh",
    "name": "中文",
    "base": "/"
  },
  {
    "id": "en",
    "name": "English",
    "base": "/en"
  }
];
export const messages = {
  "en-US": {
    "header.search.placeholder": "Type keywords...",
    "header.color.mode.light": "Light Mode",
    "header.color.mode.dark": "Dark Mode",
    "header.color.mode.auto": "Follow System",
    "header.social.github": "GitHub",
    "header.social.weibo": "Weibo",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "Zhihu",
    "header.social.yuque": "Yuque",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "Show Code",
    "previewer.actions.code.shrink": "Hide Code",
    "previewer.actions.code.editable": "Edit code with real-time preview",
    "previewer.actions.code.readonly": "Only index file is editable",
    "previewer.actions.sketch": "Copy to Sketch app",
    "previewer.actions.sketch.group": "Copy as Sketch Group",
    "previewer.actions.sketch.symbol": "Copy as Sketch Symbol",
    "previewer.actions.sketch.divider": "------------------------",
    "previewer.actions.sketch.guide": "How to paste to Sketch?",
    "previewer.actions.codesandbox": "Open in CodeSandbox",
    "previewer.actions.codepen": "Open in CodePen (Not implemented)",
    "previewer.actions.stackblitz": "Open in StackBlitz",
    "previewer.actions.separate": "Open in separate page",
    "404.title": "PAGE NOT FOUND",
    "404.back": "Back to homepage",
    "api.component.name": "Name",
    "api.component.description": "Description",
    "api.component.type": "Type",
    "api.component.default": "Default",
    "api.component.required": "(required)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "Experimental",
    "api.component.release.deprecated": "Deprecated",
    "api.component.unavailable": "apiParser must be enabled to use auto-generated API",
    "api.component.loading": "Properties definition is resolving, wait a moment...",
    "api.component.not.found": "Properties definition not found for {id} component",
    "content.tabs.default": "Doc",
    "content.footer.last.updated": "Last updated: ",
    "content.footer.actions.edit": "Improve this documentation",
    "content.footer.actions.previous": "PREV",
    "content.footer.actions.next": "NEXT",
    "search.not.found": "No content was found",
    "search.loading": "Loading...",
    "layout.sidebar.btn": "Sidebar"
  },
  "zh-CN": {
    "header.search.placeholder": "输入关键字搜索...",
    "header.color.mode.light": "亮色模式",
    "header.color.mode.dark": "暗色模式",
    "header.color.mode.auto": "跟随系统",
    "header.social.github": "GitHub",
    "header.social.weibo": "微博",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "知乎",
    "header.social.yuque": "语雀",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "展开代码",
    "previewer.actions.code.shrink": "收起代码",
    "previewer.actions.code.editable": "编辑代码可实时预览",
    "previewer.actions.code.readonly": "仅 index 可编辑",
    "previewer.actions.codesandbox": "在 CodeSandbox 中打开",
    "previewer.actions.sketch": "拷贝到 Sketch",
    "previewer.actions.sketch.group": "拷贝为 Sketch Group",
    "previewer.actions.sketch.symbol": "拷贝为 Sketch Symbol",
    "previewer.actions.sketch.divider": "----------------------",
    "previewer.actions.sketch.guide": "如何粘贴到 SKetch？",
    "previewer.actions.stackblitz": "在 StackBlitz 中打开",
    "previewer.actions.separate": "在独立页面中打开",
    "404.title": "页面未找到",
    "404.back": "返回首页",
    "api.component.name": "属性名",
    "api.component.description": "描述",
    "api.component.type": "类型",
    "api.component.default": "默认值",
    "api.component.required": "(必选)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "实验性",
    "api.component.release.deprecated": "废弃",
    "api.component.unavailable": "必须启用 apiParser 才能使用自动 API 特性",
    "api.component.loading": "属性定义正在解析中，稍等片刻...",
    "api.component.not.found": "未找到 {id} 组件的属性定义",
    "content.tabs.default": "文档",
    "content.footer.last.updated": "最后更新时间：",
    "content.footer.actions.edit": "帮助改进此文档",
    "content.footer.actions.previous": "上一篇",
    "content.footer.actions.next": "下一篇",
    "search.not.found": "未找到相关内容",
    "search.loading": "加载中...",
    "layout.sidebar.btn": "侧边菜单"
  },
  "en": {
    "yes": "Yes",
    "no": "No",
    "header.search.placeholder": "Type keywords...",
    "header.color.mode.light": "Light Mode",
    "header.color.mode.dark": "Dark Mode",
    "header.color.mode.auto": "Follow System",
    "header.social.github": "GitHub",
    "header.social.weibo": "Weibo",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "Zhihu",
    "header.social.yuque": "Yuque",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "Show Code",
    "previewer.actions.code.shrink": "Hide Code",
    "previewer.actions.code.editable": "Edit code with real-time preview",
    "previewer.actions.code.readonly": "Only index file is editable",
    "previewer.actions.sketch": "Copy to Sketch app",
    "previewer.actions.sketch.group": "Copy as Sketch Group",
    "previewer.actions.sketch.symbol": "Copy as Sketch Symbol",
    "previewer.actions.sketch.divider": "------------------------",
    "previewer.actions.sketch.guide": "How to paste to Sketch?",
    "previewer.actions.codesandbox": "Open in CodeSandbox",
    "previewer.actions.codepen": "Open in CodePen (Not implemented)",
    "previewer.actions.stackblitz": "Open in StackBlitz",
    "previewer.actions.separate": "Open in separate page",
    "404.title": "PAGE NOT FOUND",
    "404.back": "Back to homepage",
    "api.component.name": "Name",
    "api.component.description": "Description",
    "api.component.type": "Type",
    "api.component.default": "Default",
    "api.component.required": "(required)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "Experimental",
    "api.component.release.deprecated": "Deprecated",
    "api.component.unavailable": "apiParser must be enabled to use auto-generated API",
    "api.component.loading": "Properties definition is resolving, wait a moment...",
    "api.component.not.found": "Properties definition not found for {id} component",
    "content.tabs.default": "Doc",
    "content.footer.last.updated": "Last updated: ",
    "content.footer.actions.edit": "Improve this documentation",
    "content.footer.actions.previous": "PREV",
    "content.footer.actions.next": "NEXT",
    "search.not.found": "No content was found",
    "search.loading": "Loading...",
    "layout.sidebar.btn": "Sidebar",
    "index.serach": "Search...",
    "所有产品": "Products",
    "周边生态": "Ecosystem",
    "在 GitHub 上编辑": "Edit on GitHub",
    "贡献者": "Contributors",
    "演示": "Examples",
    "代码演示": "Examples",
    "设计指引": "Design Guide",
    "搜索…": "Search…",
    "description": "Collapse all",
    "经典布局": "Classic",
    "三栏布局": "Three Cloumn",
    "两栏布局": "Two Cloumn",
    "分类色板": "Qualitative Palette",
    "顺序色板": "Sequential Palette",
    "发散色板": "Diverging Palette",
    "查看更多色板用法": "For More Useage",
    "切换至电脑视图": "Change to desktop view",
    "切换至平板视图": "Change to tablet view",
    "切换至移动端视图": "Change to mobile view",
    "进入全屏": "Enter Fullscreen",
    "离开全屏": "Exit Fullscreen",
    "产品首页": "Home Page",
    "图表示例": "Examples",
    "现在开始使用": "Getting Started",
    "使用文档": "Manual",
    "组件示例": "Examples",
    "基础产品": "Basic Products",
    "拓展产品": "Extension Products",
    "API 文档": "API",
    "正在施工中...": "Coming Soon...",
    "更新日志": "Changelog",
    "GitHub 仓库": "GitHub Repository",
    "国内镜像": "China Mirror",
    "蚂蚁数据可视化": "Liven Data Lively",
    "AntV 是蚂蚁集团全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。": "AntV is a new generation of data visualization technique from Ant Group. We provide best practices of data visualization with simplicity, convenience, profession, reliability, and infinite possibilities.",
    "可视化引擎": "Visualization Engine",
    "图可视化引擎": "Graph Visualization",
    "移动可视化方案": "Mobile Charts",
    "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求。": "An elegant, interactive and flexible native charting library for mobile.",
    "地理空间数据可视化": "Geospatial Visualization",
    "开箱即用的图表库": "A Charting Library",
    "X6 图编辑引擎": "X6 JavaScript Diagramming Library",
    "图编辑引擎": "JavaScript Diagramming Library",
    "AVA 是为了更简便的可视分析而生的技术框架。": "AVA is a framework for more convenient Visual Analytics.",
    "开箱即用、易于配置、极致体验的通用图表库。": "Pretty interactive charts out of box",
    "图表魔方": "Charts Maker",
    "生成图表": "Create charts",
    "AntV 在线图表制作利器。": "Create pretty charts without code",
    "数据驱动，高度易用，可扩展的可视化图形语法。": "Data-driven visual language with a high level of usability and scalability",
    "便捷的关系数据可视化引擎与图分析工具。": "A Graph Visualization Framework in JavaScript",
    "高性能/高渲染质量的地理空间数据可视化框架。": "Large-scale WebGL-powered Geospatial Data Visualization",
    "专注于移动端的可视化解决方案，兼容 H5/小程序/Weex 等多端环境": "An elegant, interactive and flexible charting library for mobile",
    "基于 G6 封装的图分析应用组件。": "A react toolkit for graph analysis based on G6",
    "极易定制、开箱即用、数据驱动的图编辑引擎": "Data-driven diagramming library with a high level of usability and customization.",
    "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求": "An elegant, interactive and flexible native charting library for mobile.",
    "墨者学院": "Mohist Academy",
    "基于商业场景下的数据可视化解决方案": "Business visualization solution",
    "基于 G2Plot 实现的 React 可视化图表库": "A React chart library based on G2Plot",
    "学院首页": "Home Page",
    "数据可视化社团": "Visualization Community",
    "语雀社区": "Yuque",
    "钉钉服务群": "DingTalk Group",
    "扫码进 ChartCube 服务群": "Scan QRCode",
    "欢迎进入 2020 可视化智能研发时代": "New era of intelligent VIS",
    "AntV 11-22 品牌日：知源·致远": "11-22, AntV brand day!",
    "G2Plot 图表库发布": "G2Plot is released",
    "执行代码": "Run code",
    "在 CodeSandbox 中打开": "Open in CodeSandbox",
    "在 Riddle 中打开": "Open in Riddle",
    "在 StackBlitz 中打开": "Open in StackBlitz",
    "HTML 代码": "Html Source Code",
    "取消": "Cancel",
    "提交": "Submit",
    "关于我们": "About us",
    "返回旧版": "Old site",
    "查看详情": "More",
    "上新啦，点击直达：": "New demos online. Click to visit: ",
    "React 应用开发框架": "React Application Framework",
    "组件/文档研发工具": "Component doc generator",
    "React Hooks 库": "React Hooks Library",
    "设计动效": "Motion Solution",
    "社区": "Community",
    "资源": "Resource",
    "StackOverflow": "StackOverflow",
    "体验科技专栏": "Ant Financial Experience Tech",
    "帮助": "Help",
    "蚂蚁体验科技大会": "Experience Tech Conference",
    "WeaveFox 智能研发技术社区": "AI Developer Community",
    "标准版基础产品": "Standard basic products",
    "标准版扩展产品": "Standard extended products",
    "移动定制（F版）产品": "Mobile (F series) products",
    "感谢信赖": "WE ARE TRUSTED BY",
    "更多产品": "More Productions",
    "在 GitHub 上编辑此页": "Edit this page on GitHub",
    "文档贡献者": "Contributors",
    "这个页面对你有帮助吗？": "Was this page helpful?",
    "如果遇到问题或发现某些功能无法正常工作，请通过": "If something is broken or if you need a reply to a problem you've encountered, please ",
    "提交问题报告": "open an issue instead",
    "来反馈。否则，团队将无法提供进一步的答复或获取更多信息。": ". Otherwise, the team won't be able to answer back or ask for more information.",
    "你觉得我们可以如何改进此页面？（可选）": "How can we improve this page? (optional)",
    "你认为这个页面有哪些做的好的地方？（可选）": "What did you like about this page? (optional)",
    "你认为": "How can we improve",
    "部分如何改进更好？": "section? ",
    "谢谢你的反馈意见！": "Feedback Submitted",
    "报错了，请稍后再试": "Error, please try again later",
    "感谢你的支持！": "Thank you for your feedback!",
    "如果问题持续，请前往 GitHub 提交 issue。": "Go head to GitHub issue if the problem persists.",
    "你遇到的问题是什么？": "What kind of problem are you facing?",
    "🚀 留下你的真实感受": "🚀 What is the reason for your feedback?",
    "容易理解": "Easy to understand",
    "解决了我的问题": "Resolved my problem",
    "其它": "Other",
    "缺少我需要的信息": "Missing the information I need",
    "过于复杂/步骤太多": "Too complicated / Too many steps",
    "内容更新不及时": "Out of date",
    "示例/代码有问题": "Sample / code issue",
    "上一篇": "Previous",
    "下一篇": "Next",
    "演示代码报错，请检查": "演示代码报错，请检查",
    "阅读时间约": "Reading needs",
    "分钟": "minutes",
    "没有找到查询结果": "No query result found",
    "企业级 UI 设计语言": "Enterprise UI design language",
    "知识创作与分享工具": "Knowledge creation and Sharing tool",
    "语雀": "Yuque",
    "企业级 Node 开发框架": "Enterprise-class Node development framework",
    "Sketch 工具集": "Sketch Tool set",
    "互动图形解决方案": "Interactive solution",
    "前端智能研发": "AI Coding Assistant"
  },
  "zh": {
    "yes": "是",
    "no": "否",
    "header.search.placeholder": "输入关键字搜索...",
    "header.color.mode.light": "亮色模式",
    "header.color.mode.dark": "暗色模式",
    "header.color.mode.auto": "跟随系统",
    "header.social.github": "GitHub",
    "header.social.weibo": "微博",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "知乎",
    "header.social.yuque": "语雀",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "展开代码",
    "previewer.actions.code.shrink": "收起代码",
    "previewer.actions.code.editable": "编辑代码可实时预览",
    "previewer.actions.code.readonly": "仅 index 可编辑",
    "previewer.actions.codesandbox": "在 CodeSandbox 中打开",
    "previewer.actions.sketch": "拷贝到 Sketch",
    "previewer.actions.sketch.group": "拷贝为 Sketch Group",
    "previewer.actions.sketch.symbol": "拷贝为 Sketch Symbol",
    "previewer.actions.sketch.divider": "----------------------",
    "previewer.actions.sketch.guide": "如何粘贴到 SKetch？",
    "previewer.actions.stackblitz": "在 StackBlitz 中打开",
    "previewer.actions.separate": "在独立页面中打开",
    "404.title": "页面未找到",
    "404.back": "返回首页",
    "api.component.name": "属性名",
    "api.component.description": "描述",
    "api.component.type": "类型",
    "api.component.default": "默认值",
    "api.component.required": "(必选)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "实验性",
    "api.component.release.deprecated": "废弃",
    "api.component.unavailable": "必须启用 apiParser 才能使用自动 API 特性",
    "api.component.loading": "属性定义正在解析中，稍等片刻...",
    "api.component.not.found": "未找到 {id} 组件的属性定义",
    "content.tabs.default": "文档",
    "content.footer.last.updated": "最后更新时间：",
    "content.footer.actions.edit": "在 GitHub 上编辑此页",
    "content.footer.actions.previous": "上一篇",
    "content.footer.actions.next": "下一篇",
    "search.not.found": "未找到相关内容",
    "search.loading": "加载中...",
    "layout.sidebar.btn": "侧边菜单",
    "index.serach": "index.serach",
    "所有产品": "所有产品",
    "周边生态": "周边生态",
    "在 GitHub 上编辑": "在 GitHub 上编辑",
    "贡献者": "贡献者",
    "演示": "演示",
    "代码演示": "代码演示",
    "设计指引": "设计指引",
    "搜索…": "搜索…",
    "收起所有": "收起所有",
    "经典布局": "经典布局",
    "三栏布局": "三栏布局",
    "两栏布局": "两栏布局",
    "分类色板": "分类色板",
    "顺序色板": "顺序色板",
    "发散色板": "发散色板",
    "查看更多色板用法": "查看更多色板用法",
    "切换至电脑视图": "切换至电脑视图",
    "切换至平板视图": "切换至平板视图",
    "切换至移动端视图": "切换至移动端视图",
    "进入全屏": "进入全屏",
    "离开全屏": "离开全屏",
    "产品首页": "产品首页",
    "图表示例": "图表示例",
    "现在开始使用": "现在开始使用",
    "使用文档": "使用文档",
    "组件示例": "组件示例",
    "基础产品": "基础产品",
    "拓展产品": "拓展产品",
    "API 文档": "API 文档",
    "正在施工中...": "正在施工中...",
    "更新日志": "更新日志",
    "GitHub 仓库": "GitHub 仓库",
    "国内镜像": "国内镜像",
    "蚂蚁数据可视化": "蚂蚁数据可视化",
    "AntV 是蚂蚁集团全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。": "AntV 是蚂蚁集团全新一代数据可视化解决方案，致力于提供一套简单方便、专业可靠、无限可能的数据可视化最佳实践。",
    "可视化引擎": "可视化引擎",
    "图可视化引擎": "图可视化引擎",
    "移动可视化方案": "移动可视化方案",
    "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求。": "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求。",
    "地理空间数据可视化": "地理空间数据可视化",
    "开箱即用的图表库": "开箱即用的图表库",
    "X6 图编辑引擎": "X6 图编辑引擎",
    "图编辑引擎": "图编辑引擎",
    "AVA 是为了更简便的可视分析而生的技术框架。": "AVA 是为了更简便的可视分析而生的技术框架。",
    "开箱即用、易于配置、极致体验的通用图表库。": "开箱即用、易于配置、极致体验的通用图表库。",
    "图表魔方": "图表魔方",
    "生成图表": "生成图表",
    "AntV 在线图表制作利器。": "AntV 在线图表制作利器。",
    "数据驱动，高度易用，可扩展的可视化图形语法。": "数据驱动，高度易用，可扩展的可视化图形语法。",
    "便捷的关系数据可视化引擎与图分析工具。": "便捷的关系数据可视化引擎与图分析工具。",
    "高性能/高渲染质量的地理空间数据可视化框架。": "高性能/高渲染质量的地理空间数据可视化框架。",
    "专注于移动端的可视化解决方案，兼容 H5/小程序/Weex 等多端环境": "专注于移动端的可视化解决方案，兼容 H5/小程序/Weex 等多端环境",
    "基于 G6 封装的图分析应用组件。": "基于 G6 封装的图分析应用组件。",
    "极易定制、开箱即用、数据驱动的图编辑引擎": "极易定制、开箱即用、数据驱动的图编辑引擎",
    "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求": "跨平台高性能的移动端可视化解决方案，满足你的各种图表需求",
    "墨者学院": "墨者学院",
    "基于商业场景下的数据可视化解决方案": "基于商业场景下的数据可视化解决方案",
    "基于 G2Plot 实现的 React 可视化图表库": "基于 G2Plot 实现的 React 可视化图表库",
    "学院首页": "学院首页",
    "数据可视化社团": "数据可视化社团",
    "语雀社区": "语雀社区",
    "钉钉服务群": "钉钉服务群",
    "扫码进 ChartCube 服务群": "扫码进 ChartCube 服务群",
    "欢迎进入 2020 可视化智能研发时代": "欢迎进入 2020 可视化智能研发时代",
    "AntV 11-22 品牌日：知源·致远": "AntV 11-22 品牌日：知源·致远",
    "G2Plot 图表库发布": "G2Plot 图表库发布",
    "执行代码": "执行代码",
    "在 CodeSandbox 中打开": "在 CodeSandbox 中打开",
    "在 Riddle 中打开": "在 Riddle 中打开",
    "在 StackBlitz 中打开": "在 StackBlitz 中打开",
    "HTML 代码": "HTML 代码",
    "取消": "取消",
    "提交": "提交",
    "关于我们": "关于我们",
    "返回旧版": "返回旧版",
    "查看详情": "查看详情",
    "上新啦，点击直达：": "上新啦，点击直达：",
    "React 应用开发框架": "React 应用开发框架",
    "组件/文档研发工具": "组件/文档研发工具",
    "React Hooks 库": "React Hooks 库",
    "设计动效": "设计动效",
    "社区": "社区",
    "资源": "资源",
    "StackOverflow": "StackOverflow",
    "体验科技专栏": "体验科技专栏",
    "帮助": "帮助",
    "蚂蚁体验科技大会": "蚂蚁体验科技大会",
    "WeaveFox 智能研发技术社区": "智能研发技术社区",
    "标准版基础产品": "标准版基础产品",
    "标准版扩展产品": "标准版扩展产品",
    "移动定制（F版）产品": "移动定制（F版）产品",
    "感谢信赖": "感谢信赖",
    "更多产品": "更多产品",
    "在 GitHub 上编辑此页": "在 GitHub 上编辑此页",
    "文档贡献者": "文档贡献者",
    "这个页面对你有帮助吗？": "这个页面对你有帮助吗？",
    "如果遇到问题或发现某些功能无法正常工作，请通过": "如果遇到问题或发现某些功能无法正常工作，请通过",
    "提交问题报告": "提交问题报告",
    "来反馈。否则，团队将无法提供进一步的答复或获取更多信息。": "来反馈。否则，团队将无法提供进一步的答复或获取更多信息。",
    "你觉得我们可以如何改进此页面？（可选）": "你觉得我们可以如何改进此页面？（可选）",
    "你认为这个页面有哪些做的好的地方？（可选）": "你认为这个页面有哪些做的好的地方？（可选）",
    "你认为": "你认为",
    "部分如何改进更好？": "部分如何改进更好？",
    "谢谢你的反馈意见！": "谢谢你的反馈意见！",
    "报错了，请稍后再试": "报错了，请稍后再试",
    "感谢你的支持！": "感谢你的支持！",
    "如果问题持续，请前往 GitHub 提交 issue。": "如果问题持续，请前往 GitHub 提交 issue。",
    "你遇到的问题是什么？": "你遇到的问题是什么？",
    "🚀 留下你的真实感受": "🚀 留下你的真实感受",
    "容易理解": "容易理解",
    "解决了我的问题": "有效解决了我的问题",
    "其它": "其它",
    "缺少我需要的信息": "缺少我需要的信息",
    "过于复杂/步骤太多": "过于复杂/步骤太多",
    "内容更新不及时": "内容更新不及时",
    "示例/代码有问题": "示例/代码有问题",
    "上一篇": "上一篇",
    "下一篇": "下一篇",
    "演示代码报错，请检查": "演示代码报错，请检查",
    "阅读时间约": "阅读时间约",
    "分钟": "分钟",
    "没有找到查询结果": "没有找到查询结果",
    "企业级 UI 设计语言": "企业级 UI 设计语言",
    "知识创作与分享工具": "知识创作与分享工具",
    "语雀": "语雀",
    "企业级 Node 开发框架": "企业级 Node 开发框架",
    "Sketch 工具集": "Sketch 工具集",
    "互动图形解决方案": "互动图形解决方案",
    "前端智能研发": "前端智能研发",
    "previewer.actions.codepen": "在 CodePen 中打开（未实现）"
  }
};
